(function(){
  function fmt(c){var cur=window.hcCurrency||'GBP';try{return new Intl.NumberFormat('en-GB',{style:'currency',currency:cur}).format(c/100)}catch(e){return (c/100).toFixed(2)}}
  function sync(card,changed){
    var data=card.querySelector('[data-variants]');if(!data)return;
    var vs=card._v||(card._v=JSON.parse(data.textContent));
    var groups=[].slice.call(card.querySelectorAll('.hc-opts'));
    if(!groups.length)return;
    var sel=groups.map(function(g){var b=g.querySelector('.hc-opt.is-on');return b?b.getAttribute('data-val'):null});
    var v=vs.filter(function(x){return sel.every(function(s,i){return x.options[i]===s})})[0];
    if(!v){var gi=changed||0;v=vs.filter(function(x){return x.options[gi]===sel[gi]})[0]||vs[0];sel=v.options.slice()}
    groups.forEach(function(g,i){[].forEach.call(g.querySelectorAll('.hc-opt'),function(b){
      var val=b.getAttribute('data-val');
      b.classList.toggle('is-on',val===sel[i]);
      if(i>0){b.hidden=!vs.some(function(x){return x.options[i]===val&&x.options[0]===sel[0]})}
    })});
    card.querySelector('input[name=id]').value=v.id;
    var p=fmt(v.price);
    [].forEach.call(card.querySelectorAll('[data-price]'),function(el){el.textContent=p});
    var cmp=card.querySelector('[data-compare]');var wrap=card.querySelector('.hc-card__price');
    var sale=v.compare_at_price&&v.compare_at_price>v.price;
    if(cmp){cmp.hidden=!sale;if(sale)cmp.textContent=fmt(v.compare_at_price)}
    if(wrap)wrap.classList.toggle('is-sale',!!sale);
    var btn=card.querySelector('.hc-add');if(btn)btn.disabled=!v.available;
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('.hc-opt');if(!b)return;
    var card=b.closest('[data-hc-card]');var g=b.parentNode;
    [].forEach.call(g.querySelectorAll('.hc-opt'),function(x){x.classList.toggle('is-on',x===b)});
    sync(card,[].slice.call(card.querySelectorAll('.hc-opts')).indexOf(g));
  });
  function init(){
    [].forEach.call(document.querySelectorAll('[data-hc-card]'),function(c){sync(c,0)});
    [].forEach.call(document.querySelectorAll('[data-hc-rotate]'),function(r){
      var m=r.querySelectorAll('.hc-topbar__msg');if(m.length<2)return;var i=0;
      function go(d){m[i].classList.remove('is-on');i=(i+d+m.length)%m.length;m[i].classList.add('is-on')}
      var p=r.querySelector('[data-prev]'),n=r.querySelector('[data-next]');
      if(p)p.addEventListener('click',function(){go(-1)});if(n)n.addEventListener('click',function(){go(1)});
      setInterval(function(){go(1)},5000);
    });
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
})();
